// Toasts, as the prototype's toast(): at most 3, gone after 4.2 s (7 s with Undo).
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { L } from '../lib/prefs';
import { createStore, useStoreOf } from '../lib/store';
import { Ic } from './kit';

type Toast = { id: number; msg: string; tone?: 'bad' | ''; icon?: string; undo?: () => void; out?: boolean };
const toasts = createStore({ list: [] as Toast[] });
let next = 1;

function kill(id: number) {
  toasts.set(s => ({ list: s.list.map(t => (t.id === id ? { ...t, out: true } : t)) }));
  setTimeout(() => toasts.set(s => ({ list: s.list.filter(t => t.id !== id) })), 220);
}

export function toast(msg: string, o: { tone?: 'bad'; icon?: string; undo?: () => void } = {}) {
  const t: Toast = { id: next++, msg, ...o };
  toasts.set(s => ({ list: [...s.list, t].slice(-3) }));
  setTimeout(() => kill(t.id), o.undo ? 7000 : 4200);
}

export function Toasts() {
  const { list } = useStoreOf(toasts);
  const box = document.getElementById('toasts');
  useEffect(() => () => toasts.set({ list: [] }), []);
  if (!box) return null;
  return createPortal(
    list.map(t => (
      <div key={t.id} className={'toast ' + (t.tone || '') + (t.out ? ' out' : '')} role="status">
        <Ic n={t.icon || (t.tone === 'bad' ? 'alert' : 'check')} />
        <span>{t.msg}</span>
        {t.undo ? <button type="button" className="undo" onClick={() => { t.undo?.(); kill(t.id); toast(L('Undone', 'تم التراجع'), { icon: 'undo' }); }}>{L('Undo', 'تراجع')}</button> : null}
        <button type="button" className="tx" aria-label={L('Dismiss', 'إغلاق')} onClick={() => kill(t.id)}><Ic n="x" /></button>
      </div>
    )),
    box,
  );
}
